module.exports = __webpack_public_path__ + "static/media/circular wipe.c47ca589.svg";